import * as React from "react";
import { StyleSheet, View } from "react-native";
import DbScooter from "@assets/svg/CpDeliveryBoys/db_scooter";
import Button from "@components/Button";
import { colors } from "@utils/styles";
import Text from "@components/CustomText";
import t from "@constants/localization";

const NoDeliveryBoys = ({ navigation }) => {
  const onPressAddDeliveryBoy = () => {
    navigation.navigate("CreateDbOrList");
  };

  const PATH = "screens/CpDeliveryBoys/noDeliveryBoys";

  return (
    <>
      <View style={styles.todaysDeliveryDetails}>
        <DbScooter />
        <Text
          variant="subtitle_16"
          style={{ textAlign: "center", marginVertical: 18 }}
        >
          {t(`${PATH}/noDbText`)}
        </Text>
        <Button
          btnText={t(`${PATH}/button`)}
          onPress={onPressAddDeliveryBoy}
          buttonColor={colors.green1}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  todaysDeliveryDetails: {
    backgroundColor: "#f4f4f4",
    marginTop: "40%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default NoDeliveryBoys;
